import { ReactNode } from 'react';
import { color } from 'framer-motion';
import { HugeiconsIcon, IconSvgElement } from '@hugeicons/react';
import { UiColor } from '../types/colors';
import clsx from 'clsx';

export interface BgIconProps {
  icon?: ReactNode;
  hugeIcon?: IconSvgElement,
  color: UiColor;
  className?: string;
  size?: 'xs' | 'small' | 'medium' | 'large';
  strokeWidth?: number;
}

export const NBgIcon = ({ icon, color, hugeIcon, className, size = 'medium', strokeWidth = 2 }: BgIconProps) => {
  const sizeClasses = {
    xs: 'p-1 text-xs rounded-md',
    small: 'p-2 text-sm rounded-lg',
    medium: 'p-3 text-sm rounded-xl',
    large: 'p-4 text-lg rounded-2xl'
  }[size];

  const colorClasses = {
    primary: 'bg-primary text-black',
    secondary: 'bg-neutral-900 text-white',
    tertiary: 'bg-slate-200 text-slate-900 ',
    success: 'text-success-600 bg-success-100',
    info: 'text-info-600 bg-info-100',
    error: 'text-error-600 bg-error-100',
  }[color];

  const iconSize = {
    xs: 16,
    small: 20,
    medium: 20,
    large: 20
  };

  return (
    <div
      className={clsx(
        'inline-flex cursor-pointer relative items-center justify-center font-medium transition-all active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none grow-0 shrink-0 self-start aspect-square',
        sizeClasses,
        colorClasses,
        className
      )}
    >
      {hugeIcon &&
        <HugeiconsIcon size={iconSize[size]} strokeWidth={strokeWidth} icon={hugeIcon} />
      }
    </div>
  );
};
